import { Component } from '@angular/core';

import styles from './EmbedFullVodPlayback.Component.module.less';

@Component({
	selector: 'embed-full-vod-playback',
	host: {
		'[class]': 'styles.root'
	},
	template: `
		<div class="height-full" ui-view></div>
	`
})
export class EmbedFullVodPlaybackComponent {
	public readonly styles = styles;
}
